/*------------------------------------*\
    MODULES
\*------------------------------------*/
import loadGoogleMapsApi from "load-google-maps-api";

/*------------------------------------*\
    GOOGLE MAP
\*------------------------------------*/
class Map {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.apiKey = self.elem.getAttribute('data-key');
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        // Load the Google Maps API, passing in our API key
        loadGoogleMapsApi({ key: self.apiKey }).then(function (googleMaps) {

            // Call the function that initialises the rendering of the map
            self.googleMaps = googleMaps;

            // Fetch the map markers
            self.renderMap();

        }).catch(function (error) {
            console.error(error)
        });
    }

    /*-------------------------------------------------*\
        DECODE HTML MARKUP
    \*-------------------------------------------------*/
    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        
        return txt.value;
    }

    /*-------------------------------------------------*\
        RENDER MAP
    \*-------------------------------------------------*/
    renderMap() {
        let self = this;
        let infoWindow = new self.googleMaps.InfoWindow();

        var contacts,
            map,
            request = new XMLHttpRequest();

        // Open the AJAX request to get the marker data
        request.open('GET', '/map-locations.json', true);

        request.onload = function() {
            // If the AJAX request is successful...
            if (this.status >= 200 && this.status < 400) {
                // Parse the returned JSON and stick it in a variable
                var json = JSON.parse(this.response);
                contacts = json.locations;

                // Do the map stuff
                map = new google.maps.Map(document.querySelectorAll('.map')[0], {
                    center: {lat: 31.3347996, lng: -0.8329137},
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    zoom: 7,
                    styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f1f1f1"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"visibility":"off"},{"color":"#ffffff"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"lightness":"66"},{"saturation":"47"},{"color":"#dddddd"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"lightness":"100"},{"saturation":"0"},{"gamma":"0.00"},{"visibility":"on"},{"color":"#a7a7a7"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":"25"},{"saturation":"100"},{"visibility":"on"},{"hue":"#ff6300"},{"gamma":"0.38"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"weight":"0.01"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f1f1f1"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"lightness":"100"}]}]
                });

                // Create the marker image
                var image = {
                    url: '/assets/images/map-marker.png',
                    size: new google.maps.Size(28, 38),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(14, 38)
                };

                // Create the bounds object, which will be configure later based on the marker locations
                var bounds = new google.maps.LatLngBounds();

                for (var i = 0; i < contacts.length; i++) {
                    var contact = contacts[i];
                    var location = new google.maps.LatLng(contact.lat, contact.lng);

                    var marker = new google.maps.Marker({
                        position: location,
                        map: map,
                        icon: image,
                        title: contact.title
                    });

                    (function (marker, contact) {
                        google.maps.event.addListener(marker, "click", function (e) {

                            // Build the content for the infoWindow (there's a probably a better way to do this!)
                            var infoWindowContent = '<div class="[ map__info-window ] [ flow-vertical--2 ]"><h4 class="heading heading--quaternary text-primary">' + contact.title + '</h4><div>';

                            if (contact.contactAddress.length > 0) {
                                infoWindowContent = infoWindowContent.concat('<span class="map__info-window-item">' + self.decodeHtml(contact.contactAddress) + '</span>');
                            }

                            if (contact.contactPhoneNumber.length > 0) {
                                infoWindowContent = infoWindowContent.concat('<span class="map__info-window-item"><span class="text-primary font-weight-bold">P:</span> <a class="map__info-window-link" href="tel:' + contact.contactPhoneNumberPlain + '">' + contact.contactPhoneNumber + '</a></span>');
                            }

                            if (contact.contactEmailAddress.length > 0) {
                                infoWindowContent = infoWindowContent.concat('<span class="map__info-window-item"><span class="text-primary font-weight-bold">E:</span> <a class="map__info-window-link" href="mailto:' + contact.contactEmailAddress + '">' + contact.contactEmailAddress + '</a></span>');
                            }

                            infoWindowContent = infoWindowContent.concat("</div></div>");

                            // Add the content to the infoWindow
                            infoWindow.setContent(infoWindowContent);
                            infoWindow.open(map, marker);
                        });
                    })(marker, contact);

                    // Work out the area of the map containing markers
                    bounds.extend(marker.position);

                    // Function to center the map with all markers visible
                    var centerMap = function() {
                        map.setCenter(bounds.getCenter());
                    };

                    centerMap();

                    // Re-center and fit the map when the window is resized
                    google.maps.event.addDomListener(window, 'resize', function() {
                        centerMap();
                    });
                }
            }
        };

        // Make the AJAX request to get the marker data
        request.send();
    }
}

export default Map;